/**
 * Theme Configuration
 * Handles dark/light mode persistence and application
 */

const THEME_KEY = 'theme';

/**
 * Get stored theme from localStorage
 * @returns {'dark' | 'light'} - Returns stored theme or 'light' as default
 */
export function getStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(THEME_KEY);
  return stored === 'dark' ? 'dark' : 'light';
}

/**
 * Set theme and apply to document
 * @param {'dark' | 'light'} theme - Theme to apply
 */
export function setTheme(theme) {
  const isDark = theme === 'dark';
  
  // Persist to localStorage
  localStorage.setItem(THEME_KEY, theme);
  
  // Apply to document root
  document.documentElement.classList.toggle('dark', isDark);
  
  // Log for debugging
  console.log(`[Theme] set to ${theme}`);
  
  return theme;
}

/**
 * Toggle between dark and light theme
 * @returns {'dark' | 'light'} - The new theme after toggle
 */
export function toggleTheme() {
  const current = getStoredTheme();
  const newTheme = current === 'dark' ? 'light' : 'dark';
  return setTheme(newTheme);
}

/**
 * Initialize theme on app boot
 * Should be called once in App.js or root component
 */
export function initializeTheme() {
  const theme = getStoredTheme();
  setTheme(theme);
  return theme;
}
